if (!customElements.get("password-details")) {
  class PasswordDetails extends AccordionDetails {
    constructor() {
      super();

      this.open = false;
    }
  }
  customElements.define('password-details', PasswordDetails, { extends: 'details' });
}

// Populate the hidden `return_to` field of the password form so the user is
// redirected to the page they actually wanted after a successful login.
// Shopify's own redirect to /password never includes a `return_to` param,
// so we rely on brita-password-return-to.js having stored the last clicked
// internal link in sessionStorage. An explicit `?return_to=` query param
// (e.g. a manually crafted link) always takes priority.
document.addEventListener('DOMContentLoaded', () => {
  const STORAGE_KEY = 'brita:return_to';
  let returnTo = new URLSearchParams(window.location.search).get('return_to');

  if (!returnTo) {
    try {
      returnTo = window.sessionStorage.getItem(STORAGE_KEY);
    } catch {
      returnTo = null;
    }
  }

  if (!window.BritaPasswordUtils?.isSafeReturnTo?.(returnTo) || returnTo === '/password') {
    return;
  }

  document.querySelectorAll('input[name="return_to"]').forEach((input) => {
    input.value = returnTo;
  });
});
